<!-- <flx-app-bar title="{{ title$ | async }}"></flx-app-bar> -->
<div class="flow-action-shell">
	<div>
		<button *ngFor="let key of nodeKeys" (click)="loadComponent(nodes[key])">{{ nodes[key]?.name }}</button>
	</div>
	<flx-dynamic-loader dynamicLoaderHost></flx-dynamic-loader>
</div>
